var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ErrorType } from "../types/ErrorType";
/** Role validation errors whose server message is shown as is. */
export var ROLE_VALIDATION_ERRORS = [
    ErrorType.VALIDATION_ROLE_EXCLUSIVITY,
    ErrorType.VALIDATION_ROLE_NOT_ALLOWED_IN_ORGANIZATION,
];
export var handleUserEditErrors = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var errors, currentError, errorStatus, errorHandlers, handler;
    var _c;
    var _d, _e, _f;
    var error = _b.error, setErrorMessage = _b.setErrorMessage, setConfirmModalOpen = _b.setConfirmModalOpen, setErrorModalOpen = _b.setErrorModalOpen, formatMessage = _b.formatMessage;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                // eslint-disable-next-line no-console
                console.error("Error updating user or organizations:", error);
                return [4 /*yield*/, ((_d = error === null || error === void 0 ? void 0 : error.response) === null || _d === void 0 ? void 0 : _d.json())];
            case 1:
                errors = _g.sent();
                currentError = (_e = errors === null || errors === void 0 ? void 0 : errors.errors) === null || _e === void 0 ? void 0 : _e[0];
                errorStatus = (_f = error.response) === null || _f === void 0 ? void 0 : _f.status;
                errorHandlers = (_c = {},
                    _c[ErrorType.DUPLICATE_EMAIL] = {
                        message: formatMessage({
                            id: "ui-br-users.userCreate.error.email.exists",
                            defaultMessage: "Email již existuje.",
                        }),
                        isConfirmModal: false,
                    },
                    _c.status_409 = {
                        message: formatMessage({
                            id: "ui-br-users.userEdit.error.message.409",
                            defaultMessage: "Uživatel nebo organizace již existuje.",
                        }),
                        isConfirmModal: true,
                    },
                    _c.default = {
                        message: formatMessage({
                            id: "ui-br-users.userEdit.error.message.default",
                            defaultMessage: "Došlo k chybě při aktualizaci uživatele nebo organizací.",
                        }),
                        isConfirmModal: false,
                    },
                    _c);
                // the server explains a refused role (ExportApiClient with another role or outside NK, DB-946) in Czech
                if (ROLE_VALIDATION_ERRORS.includes(currentError === null || currentError === void 0 ? void 0 : currentError.type) &&
                    currentError.message) {
                    errorHandlers[currentError.type] = {
                        message: currentError.message,
                        isConfirmModal: false,
                    };
                }
                if ((currentError === null || currentError === void 0 ? void 0 : currentError.type) &&
                    Object.prototype.hasOwnProperty.call(errorHandlers, currentError.type)) {
                    handler = errorHandlers[currentError.type];
                }
                else if (errorStatus === 409) {
                    handler = errorHandlers.status_409;
                }
                else {
                    handler = errorHandlers.default;
                }
                setErrorMessage(handler.message);
                if (handler.isConfirmModal) {
                    setConfirmModalOpen(true);
                }
                else {
                    setErrorModalOpen(true);
                }
                return [2 /*return*/];
        }
    });
}); };
